import React, { memo } from 'react'
import { IActivityShared, IActivitySubtextBaseProps } from 'apps/fleet-planner/types'
import { SharedType } from 'apps/fleet-planner/types/activityMetadata'

export interface IActivitySubtextDriverProps extends IActivitySubtextBaseProps<IActivityShared> {}

export const ActivitySubtextDriver = memo<IActivitySubtextDriverProps>(({ activity }) => {
  const { metadata } = activity || {}
  const { sharedVia = [], sharedWithDriverName } = metadata || {}

  const getSharedViaText = () => {
    const hasEmail = sharedVia.includes(SharedType.email)
    const hasText = sharedVia.includes(SharedType.sms)

    const labelValues = []
    if (hasText) labelValues.push('text message')
    if (hasEmail) labelValues.push('email')
    return labelValues.join(' and ')
  }

  return (
    <div className='load-details-activity-subtext-subscriber '>
      {sharedWithDriverName} received a {getSharedViaText()}.
    </div>
  )
})
